import mapKnownValues from "../utils/mapKnownValues";

export enum TransferOptionValues {
  employerSponsored = "EMPLOYER_SPONSORED",
  ira = "IRA",
  managedIRA = "MANAGED_IRA",
  wait = "WAIT",

  // This is the default value the front end uses if no response is returned from the backend
  // We'll also use this to determine if the user has options available. If all answers are "NO_OPTION",
  // then we can assume no options are available for the user
  noOption = "NO_OPTION_YET",
}

export enum DestinationTransferOptions {
  exploreExistingDestinationOptions = "exploreExistingDestinationOptions",
  employerOnly = "Employer Only",
  employerSponsored = "Employer Sponsored",
  newEmployerSponsored = "New Employer Sponsored",
  intoIra = "Into an IRA",
  intoNewIra = "Into new IRA",
  roboIra = "Robo IRA",
  cashOut = "Cash Out",
  leaveFund = "Leave Fund",
  noEmployer = "NoEmployer",
  seeOtherOptions = "See other options",
}

export type TransferOptionsResponse = {
  FIRST: TransferOptionValues;
  SECOND: TransferOptionValues;
} | null;

export default class TransferOptions {
  FIRST = TransferOptionValues.noOption;
  SECOND = TransferOptionValues.noOption;

  constructor(params: Partial<TransferOptions> = {}) {
    mapKnownValues(this, params);
  }

  get hasOptions() {
    return this.FIRST !== TransferOptionValues.noOption && this.SECOND !== TransferOptionValues.noOption;
  }

  get orderedOptions(): Partial<Record<TransferOptionValues, number>> {
    return {
      [this.FIRST]: 1,
      [this.SECOND]: 2,
    };
  }

  static fromAPI(response: TransferOptionsResponse) {
    return new TransferOptions(response || {});
  }
}
